import { render, staticRenderFns } from "./BasicSignupForm.vue?vue&type=template&id=63402d52&"
import script from "./BasicSignupForm.vue?vue&type=script&lang=ts&"
export * from "./BasicSignupForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports